export const contactColumns = [


  {
    name: "Nombre",
    selector: (row) => row.first_name,
    sortable: true,
    center: false,
    wrap: true,
  },
  {
    name: "Apellido",
    selector: (row) => row.last_name,
    sortable: true,
    center: false,
    wrap: true,
  },
  {
    name: "Cargo",
    selector: (row) => row.charge?.name,
    sortable: true,
    center: false,
  },
];
